import * as React from 'react';
import { Header } from './Header/Header';
export function MinimalLayout(props) {
    const { logo, children, masthead } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { brandLogo: logo, masthead: masthead }),
        React.createElement("main", null, children)));
}
